/**
 * Created by wangdi on 26/5/17.
 */
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './dashboard/home/home.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { TableComponent } from './dashboard/table/table.component';
import { NotificationComponent } from './dashboard/notification/notification.component';
import { SweetAlertComponent } from './dashboard/sweetalert/sweetalert.component';
import { SettingsComponent } from './dashboard/settings/settings.component';
import { PriceTableComponent } from './dashboard/component/pricetable/pricetable.component';
import { PanelsComponent} from './dashboard/component/panels/panels.component';
import { WizardComponent } from './dashboard/component/wizard/wizard.component';

import { RootComponent } from './dashboard/root/root.component';
import { LoginComponent } from './page/login/login.component';
import { LockComponent } from './page/lock/lock.component';
import { RegisterComponent } from './page/register/register.component';
// import { AddressComponent } from './pages/address/address.component';
import { DomainsComponent } from './dashboard/domains/domains.component';
import { DriversComponent } from './dashboard/administration/drivers/drivers.component';
import { VehiclesComponent } from './dashboard/administration/vehicles/vehicles.component';
import { VerificationComponent } from './page/verification/verification.component';
import { CustomersComponent } from './dashboard/administration/customers/customers.component';
import { CustomerDomainComponent } from './dashboard/domains/customer-domain/customer-domain.component';
// import { RoutesComponent } from './dashboard/domains/routes/routes.component';

import { RouteDetailComponent } from './dashboard/routes/route-detail/route-detail.component';
import { RoutesComponent } from './dashboard/routes/routes.component';
import { LocationsComponent } from './dashboard/locations/locations.component';
import { PassengersComponent } from './dashboard/passengers/passengers.component';
import { RecurrenciesComponent } from './dashboard/administration/recurrencies/recurrencies.component';
import { SummaryComponent } from './dashboard/summary/summary.component';
import { ForgotPasswordComponent } from './page/forgot-password/forgot-password.component';

const routes: Routes = [
  {path: '', component: LoginComponent},
  // {path: '', component: RootComponent},
  {path: 'lock', component: LockComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'register', component: RegisterComponent},
  {path: 'verification', component: VerificationComponent},
  {path: 'dashboard', component: RootComponent, children: [
    {path: '', component: SummaryComponent},
    // {path: 'address', component: AddressComponent},
    {path: 'profile', component: ProfileComponent},
    {path: 'table', component: TableComponent},
    {path: 'notification', component: NotificationComponent},
    {path: 'alert', component: SweetAlertComponent},
    {path: 'settings', component: SettingsComponent},
    {path: 'components/price-table', component: PriceTableComponent},
    {path: 'components/panels', component: PanelsComponent},
    {path: 'components/wizard', component: WizardComponent},
    {path: 'domains', component: DomainsComponent},
    {path: 'domains/:id', component: CustomerDomainComponent},
    {path: 'domains/:id/routes', component: RoutesComponent},
    {path: 'domains/:id/route-detail', component: RouteDetailComponent},
    {path: 'domains/:id/route-detail/:routeId', component: RouteDetailComponent},
    {path: 'domains/:id/locations', component: LocationsComponent},
    {path: 'domains/:id/passengers', component: PassengersComponent},
    {path: 'administration/drivers', component: DriversComponent},
    {path: 'administration/vehicles', component: VehiclesComponent},
    {path: 'administration/customers', component: CustomersComponent},
    {path: 'administration/recurrencies', component: RecurrenciesComponent}
  ]}
];

export const routing = RouterModule.forRoot(routes);

